import React from 'react';
import _ from 'lodash';

import _masterSlideLoader from '../../utilities/masterSlideLoader';
import { AnchorList } from './AnchorList';
import { FIELD_NAVI_LIST } from '../../utilities/constants';
import dialogLoader from '../../utilities/dialogLoader';
import { CloseEditView } from '../CloseEditView';

import { FieldData } from '../../services/FieldTree';

/**
 * Field information menu
 * @props {number} fieldId: field id
 * @props {string} selectedTab: selected slide name
 * @props {boolean} disabledCooperationCcus: disabled cooperation ccus page in menu
 * @props {boolean} isEditable: is true if the page is editing
 */
export class FieldNaviList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ichiplusLinkedFlag: false,
    };
  }

  /**
   * move to page of slide
   * @param pageName slide page name
   */
  moveToPage = pageName => {
    _masterSlideLoader.show(pageName, {
      state: {
        id: this.props.fieldId,
      },
    });
  };

  /**
   * return navigation list
   * @returns {object}
   */
  getNavigationList = () => {
    const {
      disabledCooperationCcus,
      selectedTab,
      showJvSettingTab,
    } = this.props;
    const { ichiplusLinkedFlag } = this.state;

    const fieldInfoNaviName =
      selectedTab === 'FieldRegister' ? selectedTab : 'FieldsDetail';
    let naviList = [
      {
        name: fieldInfoNaviName,
        label: '現場基本情報',
      },
      {
        name: 'FieldCcusCooperation',
        label: '現場CCUS連携情報',
        disabled: disabledCooperationCcus,
      },
    ];
    if (showJvSettingTab) {
      naviList.push({
        name: 'FieldJvSetting',
        label: 'JV構成会社',
      });
    }
    if (ichiplusLinkedFlag) {
      naviList.push({
        name: FIELD_NAVI_LIST.ICHI_PLUS_LINKAGE_DETAIL.TAB_NAME,
        label: FIELD_NAVI_LIST.ICHI_PLUS_LINKAGE_DETAIL.LABEL,
      });
    }

    return naviList;
  };

  componentDidMount() {
    const { fieldId, selectedTab } = this.props;
    FieldData(fieldId).then(response => {
      const ichiplusLinkedFlag = _.get(
        response,
        'entities.field.ichiplus_linked_flag'
      );
      if (
        selectedTab === FIELD_NAVI_LIST.ICHI_PLUS_LINKAGE_DETAIL.TAB_NAME &&
        !ichiplusLinkedFlag
      ) {
        return window.location.replace('/error-permission');
      }
      this.setState({ ichiplusLinkedFlag });
    });
  }

  /**
   * handle click of navigation item
   * @param index navigation item index
   */
  handleClickNaviItem = index => {
    const { isEditable, selectedTab, closeEditingDialog } = this.props;
    const _closeEditingDialog = !_.isObject(closeEditingDialog)
      ? {}
      : closeEditingDialog;
    const navigationList = this.getNavigationList();
    const { name, disabled } = navigationList[index];

    if (disabled || selectedTab === 'FieldRegister') {
      return;
    }

    if (isEditable) {
      dialogLoader.show(CloseEditView, {
        title: _closeEditingDialog.title,
        message: _closeEditingDialog.message,
        confirmButtonName: _closeEditingDialog.confirmButtonName,
        multilineText: _closeEditingDialog.multilineText,
        callback: {
          close: () => {
            dialogLoader.close();
          },
          clear: () => {
            this.moveToPage(name);
            dialogLoader.close();
          },
        },
      });
      return;
    }
    this.moveToPage(name);
  };

  render() {
    const { selectedTab } = this.props;

    return (
      <ul className='contruction-navi-list FieldNaviList'>
        {_.map(this.getNavigationList(), ({ name, label, disabled }, index) => {
          return (
            <AnchorList
              key={name}
              label={label}
              isSelected={selectedTab === name}
              onClick={() => this.handleClickNaviItem(index)}
              className={disabled ? 'tab-disabled' : ''}
            />
          );
        })}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/list/FieldNaviList.jsx